import { render, staticRenderFns } from "./PopWarning.vue?vue&type=template&id=0e1a660d&scoped=true"
import script from "./PopWarning.vue?vue&type=script&lang=ts"
export * from "./PopWarning.vue?vue&type=script&lang=ts"
import style0 from "./PopWarning.vue?vue&type=style&index=0&id=0e1a660d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a660d",
  null
  
)

export default component.exports